import React, { useState, useEffect } from "react";
import { AdminSidebar } from "./AdminSidebar";
import { AdminHeader } from "./AdminHeader";
import { useSidebar } from "@/contexts/SidebarContext";
import { ScrollToTopLayout } from "../ScrollToTopLayout";

export const AdminLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isCollapsed } = useSidebar();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Sidebar genişliği
  const sidebarWidth = isCollapsed ? 56 : 250; // Tailwind w-14 = 56px, w-[250px] = 250px

  return (
    <ScrollToTopLayout>
      <div className="h-screen flex flex-col bg-ds-dark">
        <AdminHeader />
        <div className="flex flex-1 overflow-hidden">
          <AdminSidebar />
          <main
            className="flex-1 overflow-auto pt-13 transition-all duration-300 max-lg:ml-0 max-lg:mt-0"
            style={{
              marginLeft: isMobile ? 0 : sidebarWidth,
            }}
          >
            <div className="px-6 py-6">
              {children}
            </div>
          </main>
        </div>
      </div>
    </ScrollToTopLayout>
  );
};
